import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import type { User } from './types';

// 1:1 паттерн mcms-front/src/entities/user/model/userSlice.ts. State кэширует
// user-данные из react-query (см. useUser.ts), чтобы компоненты могли
// читать через useAppSelector(selectUser) — это паттерн фронтендера.

interface UserState {
  data: User | null;
  isLoading: boolean;
}

const initialState: UserState = {
  data: null,
  isLoading: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setUser(state, action: PayloadAction<User | null>) {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearUser(state) {
      state.data = null;
      state.isLoading = false;
    },
  },
});

export const selectUser = (state: RootState) => state.user.data;
export const selectUserLoading = (state: RootState) => state.user.isLoading;

export const { setUserLoading, setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
